import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Invoice, InvoiceCreate, InvoiceFilter } from '../data/invoice';

export function createInvoiceService(client: AxiosInstance) {
  return createCrudService<Invoice, InvoiceCreate, InvoiceFilter>(client, '/Invoice', 'invoiceId');
}

export type InvoiceService = CrudService<Invoice, InvoiceCreate, InvoiceFilter>;
